import { createBinderV1 } from './create-binder-v1.js';
import { createBinderV2 } from './create-binder-v2.js';
import { createBinderV3 } from './create-binder-v3.js';
export { getBaseSiteId } from './get-base-site-id.js';
export { getCountryCode } from './get-country-code.js';
export { getCurrency } from './get-currency.js';
export { getLanguage } from './get-language.js';
export { getLanguageTag } from './get-language-tag.js';
export function defineLocaleService(options) {
    return {
        id: `locale-service`,
        optionalDependencies: {
            featureServices: {
                's2:logger': `^1.0.0`,
            },
        },
        create: ({ featureServices }) => {
            const { 's2:logger': logger = console } = featureServices;
            return {
                '1.0.0': createBinderV1({ locale: options.locale, logger }),
                '2.2.0': createBinderV2({ ...options, logger }),
                '3.0.0': createBinderV3(options),
            };
        },
    };
}
//# sourceMappingURL=index.js.map